module.exports = __webpack_public_path__ + "media/application/images/2020/redesign2020-header-search-49ae27245ead8b38048c7ac9d4f330b8.svg";